export class ingSalActivoFijo{
    public clasificacion: string;//
    public descripcion: string;
    public marca: string;//
    public serialActivoFijo: string;//
    public numeroIngresos: number;//
    public observaciones: string;//
    public fechaUltimoIngreso: Date;
    public estado: string;//
    public sede: string;
    public idRegIngSalActivoFijo: number;
    public idActivo: number;
    public placaInventario: string;//
    public tipoIdFuncionario: string;
    public numeroIdFuncionario: string;
    public fechaUltimaSalida: Date;
    public nombreCompletoFuncionario?: string;
    public banderaAutorizado? : boolean;
    public asignadoAutorizado? : string;
	
	constructor(){
        
    }			
	
}